<template>
  <div>
    <table class="action-prop-table">
      <tr>
        <th>conf</th>
        <td>{{pendingConfig}}</td>
      </tr>
    </table>

    <p v-if="isPartOfMassPending">
      This pending is part of
      <mass-pending-link
        :massPendingId="pending.massPendingId"
        lable="mass pending"
      />.
    </p>
  </div>
</template>

<script>
import { isNumberSpecified } from '../util';

import MassPendingLink from './MassPendingLink.vue';

export default {
  name: 'PlayerPendingInfoFollowingLink',

  components: {
    MassPendingLink,
  },

  props: {
    pending: {
      type: Object,
      required: true,
    }
  },

  computed: {
    pendingConfig() {
      return this.pending.text_config;
    },

    isPartOfMassPending() {
      return isNumberSpecified(this.pending.massPendingId);
    },
  },
}
</script>

<style scoped>
  .action-prop-table:not(:last-child) {
    margin-bottom: 0.5rem;
  }
</style>
